// src/components/PP2Exams.js
import React from 'react';
import ExamsList from './ExamsListPerYear';


const Grade8Examinations = ({ isLoggedIn, clearToken }) => {
    const items = [
        { name: 'GRADE 8 EXAMINATIONS 2026 ', year: 2026, bgColor: 'rgba(0, 0, 0, 0.2)', textColor: 'rgb(0, 0, 0)', path: "jss", value: "grade8/examinations" },
        { name: 'GRADE 8 EXAMINATIONS 2025 ', year: 2025, bgColor: 'rgba(0, 0, 0, 0.1)', textColor: 'rgb(0, 0, 0)', path: "jss", value: "grade8/examinations" },

    ];

    return (
        <>

        <ExamsList           
            heading="GRADE 8"
            items={items}
            navigateTo="/grade8/examinations/download"
        />
        </>
    );
};

export default Grade8Examinations;
